/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddEntityMembershipPayload } from '../models/AddEntityMembershipPayload';
import type { AgreementParseRecordRead } from '../models/AgreementParseRecordRead';
import type { AIExtractionContextCreate } from '../models/AIExtractionContextCreate';
import type { AIExtractionContextRead } from '../models/AIExtractionContextRead';
import type { AnalyzeBankStatementsPayload } from '../models/AnalyzeBankStatementsPayload';
import type { AssetAccountBalanceRead } from '../models/AssetAccountBalanceRead';
import type { AssetAccountCreate } from '../models/AssetAccountCreate';
import type { AssetAccountDocumentCreatePayload } from '../models/AssetAccountDocumentCreatePayload';
import type { AssetAccountDocumentUpdatePayload } from '../models/AssetAccountDocumentUpdatePayload';
import type { AssetAccountRead } from '../models/AssetAccountRead';
import type { AssetAccountWithDetails } from '../models/AssetAccountWithDetails';
import type { AssetAccountWithInstitutionConnection } from '../models/AssetAccountWithInstitutionConnection';
import type { AutoMappingAIPayload } from '../models/AutoMappingAIPayload';
import type { BackfillMappingPayload } from '../models/BackfillMappingPayload';
import type { BalanceSourceTypeEnum } from '../models/BalanceSourceTypeEnum';
import type { BlockCalculationsPayload } from '../models/BlockCalculationsPayload';
import type { BlockInterpolationPayload } from '../models/BlockInterpolationPayload';
import type { BulkCreateAssetAccounts } from '../models/BulkCreateAssetAccounts';
import type { CalculateLineItemValueModResult } from '../models/CalculateLineItemValueModResult';
import type { CalculateLineItemValuesPayload } from '../models/CalculateLineItemValuesPayload';
import type { CashflowFormulaFiltersForEntity } from '../models/CashflowFormulaFiltersForEntity';
import type { CashflowLedgerRead } from '../models/CashflowLedgerRead';
import type { ClusterRead } from '../models/ClusterRead';
import type { CollectionPlanCreate } from '../models/CollectionPlanCreate';
import type { CollectionPlanRead } from '../models/CollectionPlanRead';
import type { CollectionPlanWithDetails } from '../models/CollectionPlanWithDetails';
import type { CommentaryDomain } from '../models/CommentaryDomain';
import type { CompleteTaskPayload } from '../models/CompleteTaskPayload';
import type { ConfigValueEnum } from '../models/ConfigValueEnum';
import type { CreateDeliverableFromTemplatePayload } from '../models/CreateDeliverableFromTemplatePayload';
import type { CreateStatementPayload } from '../models/CreateStatementPayload';
import type { DashboardVariableBindRead } from '../models/DashboardVariableBindRead';
import type { DatabaseRead } from '../models/DatabaseRead';
import type { DatabaseWithRowsAndColumns } from '../models/DatabaseWithRowsAndColumns';
import type { DataExtractionPayload } from '../models/DataExtractionPayload';
import type { DataExtractionResults } from '../models/DataExtractionResults';
import type { DataExtractionSummary } from '../models/DataExtractionSummary';
import type { DeliverableParseResult } from '../models/DeliverableParseResult';
import type { DeliverableWithStatuses } from '../models/DeliverableWithStatuses';
import type { DependenciesContext } from '../models/DependenciesContext';
import type { DocumentAutomationSummary } from '../models/DocumentAutomationSummary';
import type { DocumentCopyRecordWithDetails } from '../models/DocumentCopyRecordWithDetails';
import type { DocumentDetail } from '../models/DocumentDetail';
import type { DocumentRead } from '../models/DocumentRead';
import type { EntityDashboard } from '../models/EntityDashboard';
import type { EntityDashboardPresenceHeartbeatPayload } from '../models/EntityDashboardPresenceHeartbeatPayload';
import type { EntityDashboardPresenceRead } from '../models/EntityDashboardPresenceRead';
import type { EntityDetailsUpdate } from '../models/EntityDetailsUpdate';
import type { EntitySettingsRead } from '../models/EntitySettingsRead';
import type { EntityWithDetails } from '../models/EntityWithDetails';
import type { EntityWithNamespace } from '../models/EntityWithNamespace';
import type { FieldDiscoveryStartResponse } from '../models/FieldDiscoveryStartResponse';
import type { FinancialConnectionRead } from '../models/FinancialConnectionRead';
import type { FinancialInstitutionWithAssetAccounts } from '../models/FinancialInstitutionWithAssetAccounts';
import type { FormulaEntityResult } from '../models/FormulaEntityResult';
import type { FormulaRead } from '../models/FormulaRead';
import type { GenerateMappingsPayload } from '../models/GenerateMappingsPayload';
import type { InviteEntityPayload } from '../models/InviteEntityPayload';
import type { LensPayload } from '../models/LensPayload';
import type { LensRead } from '../models/LensRead';
import type { ListDocumentsPayload } from '../models/ListDocumentsPayload';
import type { ListTaskResponseForBlockTypePayload } from '../models/ListTaskResponseForBlockTypePayload';
import type { MappingPayload } from '../models/MappingPayload';
import type { MappingPropertyRead } from '../models/MappingPropertyRead';
import type { MembershipRead } from '../models/MembershipRead';
import type { MembershipWithUser } from '../models/MembershipWithUser';
import type { ModifyDatabaseRowsPayload } from '../models/ModifyDatabaseRowsPayload';
import type { MonthEnum } from '../models/MonthEnum';
import type { NamespaceRead } from '../models/NamespaceRead';
import type { NamespaceWithFeatures } from '../models/NamespaceWithFeatures';
import type { OperationReviewEntry } from '../models/OperationReviewEntry';
import type { PaginatedResponse } from '../models/PaginatedResponse';
import type { ParseDeliverablesPayload } from '../models/ParseDeliverablesPayload';
import type { ParseOnboardingChainPayload } from '../models/ParseOnboardingChainPayload';
import type { PeriodTypeEnum } from '../models/PeriodTypeEnum';
import type { PlaidConnectionRead } from '../models/PlaidConnectionRead';
import type { PreviewTaskTemplatePayload } from '../models/PreviewTaskTemplatePayload';
import type { PropertyRead } from '../models/PropertyRead';
import type { RelatedEntity } from '../models/RelatedEntity';
import type { RenderableRichText } from '../models/RenderableRichText';
import type { RenderDataExtractionContextPayload } from '../models/RenderDataExtractionContextPayload';
import type { RenderedRichText } from '../models/RenderedRichText';
import type { ReportRead } from '../models/ReportRead';
import type { ResendInvitationPayload } from '../models/ResendInvitationPayload';
import type { RestateFieldValuesPayload } from '../models/RestateFieldValuesPayload';
import type { ReviewState } from '../models/ReviewState';
import type { SetParentRelationshipsPayload } from '../models/SetParentRelationshipsPayload';
import type { SimulatedMappingResponse } from '../models/SimulatedMappingResponse';
import type { src__app__collection__data_extraction__router__LuChatPromptPayload } from '../models/src__app__collection__data_extraction__router__LuChatPromptPayload';
import type { StartDateWithDetails } from '../models/StartDateWithDetails';
import type { StatementRead } from '../models/StatementRead';
import type { StatementReport } from '../models/StatementReport';
import type { StatementUpdate } from '../models/StatementUpdate';
import type { TaskRead } from '../models/TaskRead';
import type { TaskSummary } from '../models/TaskSummary';
import type { TaskWithBlocks } from '../models/TaskWithBlocks';
import type { TrackedDatabaseRead } from '../models/TrackedDatabaseRead';
import type { UnresolvedParseRecord } from '../models/UnresolvedParseRecord';
import type { UpdateAssetAccountsPayload } from '../models/UpdateAssetAccountsPayload';
import type { UpdateFieldValuesPayload } from '../models/UpdateFieldValuesPayload';
import type { UpdateStatementBody } from '../models/UpdateStatementBody';
import type { WorkflowCreatePayload } from '../models/WorkflowCreatePayload';
import type { WorkflowSummary } from '../models/WorkflowSummary';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EntitiesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Entity
     * @param entityId
     * @returns EntityWithDetails Successful Response
     * @throws ApiError
     */
    public getEntity(
        entityId: string,
    ): CancelablePromise<EntityWithDetails> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/get-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Entity Memberships With Users
     * @param entityId
     * @returns MembershipWithUser Successful Response
     * @throws ApiError
     */
    public listEntityMembershipsWithUsers(
        entityId: string,
    ): CancelablePromise<Array<MembershipWithUser>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/list-memberships',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Cluster For Entity
     * @param entityId
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public getClusterForEntity(
        entityId: string,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/get-cluster-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Cluster For Entity Id
     * @param entityId
     * @returns ClusterRead Successful Response
     * @throws ApiError
     */
    public getClusterForEntityId(
        entityId: string,
    ): CancelablePromise<ClusterRead> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/get-cluster-for-entity-id',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Entity Namespace With Features
     * @param entityId
     * @returns NamespaceWithFeatures Successful Response
     * @throws ApiError
     */
    public getEntityNamespaceWithFeatures(
        entityId: string,
    ): CancelablePromise<NamespaceWithFeatures> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/get-entity-namespace-with-features',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Entity Settings
     * @param entityId
     * @returns EntitySettingsRead Successful Response
     * @throws ApiError
     */
    public getEntitySettings(
        entityId: string,
    ): CancelablePromise<EntitySettingsRead> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/get-entity-settings',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Entity Default Dashboard
     * @param entityId
     * @param dashboardId
     * @returns EntitySettingsRead Successful Response
     * @throws ApiError
     */
    public updateEntityDefaultDashboard(
        entityId: string,
        dashboardId: string,
    ): CancelablePromise<EntitySettingsRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/update-entity-default-dashboard',
            path: {
                'entity_id': entityId,
            },
            query: {
                'dashboard_id': dashboardId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Children Entities
     * @param entityId
     * @returns EntityWithNamespace Successful Response
     * @throws ApiError
     */
    public getChildrenEntities(
        entityId: string,
    ): CancelablePromise<Array<EntityWithNamespace>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/get-children',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Entity Namespace
     * @param entityId
     * @returns NamespaceRead Successful Response
     * @throws ApiError
     */
    public getEntityNamespace(
        entityId: string,
    ): CancelablePromise<NamespaceRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/get-entity-namespace',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List All Entity Relationships
     * @param entityId
     * @returns RelatedEntity Successful Response
     * @throws ApiError
     */
    public listAllEntityRelationships(
        entityId: string,
    ): CancelablePromise<Array<RelatedEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/list-all-entity-relationships',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Set Entity Parent Relationships
     * Set parent relationships for a single entity within a specific parent namespace.
     * Idempotent: replaces all existing parents in that namespace with the provided list.
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public setEntityParentRelationships(
        entityId: string,
        requestBody: SetParentRelationshipsPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/entities/{entity_id}/relationships',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Collection Plans For Entity
     * @param entityId
     * @returns CollectionPlanWithDetails Successful Response
     * @throws ApiError
     */
    public listCollectionPlansForEntity(
        entityId: string,
    ): CancelablePromise<Array<CollectionPlanWithDetails>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/collection-plans/list-collection-plans',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Ad Hoc Collection Plans For Entity
     * @param entityId
     * @returns CollectionPlanWithDetails Successful Response
     * @throws ApiError
     */
    public listAdHocCollectionPlansForEntity(
        entityId: string,
    ): CancelablePromise<Array<CollectionPlanWithDetails>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/collection-plans/list-ad-hoc-collection-plans',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Resume Collection Plan
     * @param entityId
     * @param workflowId
     * @returns any Successful Response
     * @throws ApiError
     */
    public resumeCollectionPlan(
        entityId: string,
        workflowId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/collection-plans/resume-collection-plan/{workflow_id}',
            path: {
                'entity_id': entityId,
                'workflow_id': workflowId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Downloadable File Ids
     * @param entityId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public listDownloadableFileIds(
        entityId: string,
        requestBody: ListTaskResponseForBlockTypePayload,
    ): CancelablePromise<Record<string, Array<string>>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/collection-plans/list-downloadable-file-ids',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Interpolated Body By Block Id
     * @param entityId
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public getInterpolatedBodyByBlockId(
        entityId: string,
        requestBody: BlockInterpolationPayload,
    ): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/collection-plans/get-interpolated-body-by-block',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Calculate Computed Fields
     * @param entityId
     * @param effectiveDate
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public calculateComputedFields(
        entityId: string,
        effectiveDate: string,
        requestBody: BlockCalculationsPayload,
    ): CancelablePromise<Record<string, (number | string | boolean | null)>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/collection-plans/calculate-computed-fields',
            path: {
                'entity_id': entityId,
            },
            query: {
                'effective_date': effectiveDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Deliverables With Status Over Time For Entity
     * @param entityId
     * @returns DeliverableWithStatuses Successful Response
     * @throws ApiError
     */
    public listDeliverablesWithStatusOverTimeForEntity(
        entityId: string,
    ): CancelablePromise<Array<DeliverableWithStatuses>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/collection-plans/list-deliverables-with-status-over-time-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Generate Start Date Candidates For Entity
     * @param entityId
     * @param fiscalYearEndMonth
     * @returns StartDateWithDetails Successful Response
     * @throws ApiError
     */
    public generateStartDateCandidatesForEntity(
        entityId: string,
        fiscalYearEndMonth: MonthEnum,
    ): CancelablePromise<Record<string, Array<StartDateWithDetails>>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/collection-plans/generate-start-date-candidates-for-entity/{fiscal_year_end_month}',
            path: {
                'entity_id': entityId,
                'fiscal_year_end_month': fiscalYearEndMonth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Existing Value By Block Id
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public getExistingValueByBlockId(
        entityId: string,
        requestBody: PreviewTaskTemplatePayload,
    ): CancelablePromise<Record<string, (number | string | Record<string, any> | boolean | null)>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/collection-plans/get-existing-value-by-block-id',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Deliverable From Template
     * @param entityId
     * @param clusterId
     * @param requestBody
     * @returns CollectionPlanWithDetails Successful Response
     * @throws ApiError
     */
    public createDeliverableFromTemplate(
        entityId: string,
        clusterId: string,
        requestBody: CreateDeliverableFromTemplatePayload,
    ): CancelablePromise<CollectionPlanWithDetails> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/collection-plans/create-deliverable-from-template/',
            path: {
                'entity_id': entityId,
            },
            query: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Parse Deliverables From Document
     * @param entityId
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public parseDeliverablesFromDocument(
        entityId: string,
        clusterId: string,
        requestBody: ParseDeliverablesPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/collection-plans/parse-deliverables-from-document/',
            path: {
                'entity_id': entityId,
            },
            query: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Parse Onboarding Chain
     * @param entityId
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public parseOnboardingChain(
        entityId: string,
        clusterId: string,
        requestBody: ParseOnboardingChainPayload,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/collection-plans/parse-onboarding-chain/',
            path: {
                'entity_id': entityId,
            },
            query: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Unresolved Parse Records For Entity
     * @param entityId
     * @returns UnresolvedParseRecord Successful Response
     * @throws ApiError
     */
    public listUnresolvedParseRecordsForEntity(
        entityId: string,
    ): CancelablePromise<Array<UnresolvedParseRecord>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/collection-plans/parse-record/unresolved',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Dismiss Parse Record
     * @param entityId
     * @param parseRecordId
     * @returns AgreementParseRecordRead Successful Response
     * @throws ApiError
     */
    public dismissParseRecord(
        entityId: string,
        parseRecordId: string,
    ): CancelablePromise<AgreementParseRecordRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/collection-plans/parse-record/{parse_record_id}/dismiss',
            path: {
                'entity_id': entityId,
                'parse_record_id': parseRecordId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Parse Result For Parse Record
     * @param entityId
     * @param parseRecordId
     * @returns any Successful Response
     * @throws ApiError
     */
    public getParseResultForParseRecord(
        entityId: string,
        parseRecordId: string,
    ): CancelablePromise<(DeliverableParseResult | null)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/collection-plans/parse-record/{parse_record_id}/parse-result',
            path: {
                'entity_id': entityId,
                'parse_record_id': parseRecordId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Review State For Parse Record
     * @param entityId
     * @param parseRecordId
     * @returns ReviewState Successful Response
     * @throws ApiError
     */
    public getReviewStateForParseRecord(
        entityId: string,
        parseRecordId: string,
    ): CancelablePromise<ReviewState> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/collection-plans/parse-record/{parse_record_id}/review-state',
            path: {
                'entity_id': entityId,
                'parse_record_id': parseRecordId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Set Operation Review Status
     * @param entityId
     * @param parseRecordId
     * @param opKey
     * @param requestBody
     * @returns ReviewState Successful Response
     * @throws ApiError
     */
    public setOperationReviewStatus(
        entityId: string,
        parseRecordId: string,
        opKey: string,
        requestBody: OperationReviewEntry,
    ): CancelablePromise<ReviewState> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/entities/{entity_id}/collection-plans/parse-record/{parse_record_id}/operations/{op_key}',
            path: {
                'entity_id': entityId,
                'parse_record_id': parseRecordId,
                'op_key': opKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Clear Operation Review Status
     * @param entityId
     * @param parseRecordId
     * @param opKey
     * @returns ReviewState Successful Response
     * @throws ApiError
     */
    public clearOperationReviewStatus(
        entityId: string,
        parseRecordId: string,
        opKey: string,
    ): CancelablePromise<ReviewState> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/entities/{entity_id}/collection-plans/parse-record/{parse_record_id}/operations/{op_key}',
            path: {
                'entity_id': entityId,
                'parse_record_id': parseRecordId,
                'op_key': opKey,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Plaid Link Token
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public createPlaidLinkToken(
        entityId: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/create-link-token',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Plaid Link Token For Update
     * @param entityId
     * @param connectionId
     * @returns any Successful Response
     * @throws ApiError
     */
    public createPlaidLinkTokenForUpdate(
        entityId: string,
        connectionId: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/create-link-token-for-update',
            path: {
                'entity_id': entityId,
            },
            query: {
                'connection_id': connectionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Plaid Connection
     * @param entityId
     * @param publicToken
     * @param requestBody
     * @returns PlaidConnectionRead Successful Response
     * @throws ApiError
     */
    public createPlaidConnection(
        entityId: string,
        publicToken: string,
        requestBody: Record<string, any>,
    ): CancelablePromise<PlaidConnectionRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/create-connection',
            path: {
                'entity_id': entityId,
            },
            query: {
                'public_token': publicToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reconnect Plaid Connection
     * @param entityId
     * @param connectionId
     * @param publicToken
     * @returns void
     * @throws ApiError
     */
    public reconnectPlaidConnection(
        entityId: string,
        connectionId: string,
        publicToken: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/update-connection/{connection_id}',
            path: {
                'entity_id': entityId,
                'connection_id': connectionId,
            },
            query: {
                'public_token': publicToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Disconnect Plaid Connection
     * @param entityId
     * @param connectionId
     * @param archive
     * @param assetAccountId
     * @returns void
     * @throws ApiError
     */
    public disconnectPlaidConnection(
        entityId: string,
        connectionId: string,
        archive?: (boolean | null),
        assetAccountId?: (string | null),
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/integrations/plaid/disconnect-connection/{connection_id}',
            path: {
                'entity_id': entityId,
                'connection_id': connectionId,
            },
            query: {
                'archive': archive,
                'asset_account_id': assetAccountId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Statement
     * @param entityId
     * @param requestBody
     * @returns StatementRead Successful Response
     * @throws ApiError
     */
    public createStatement(
        entityId: string,
        requestBody: CreateStatementPayload,
    ): CancelablePromise<StatementRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/financials/create-statement',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Statement
     * @param entityId
     * @param statementId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateStatement(
        entityId: string,
        statementId: string,
        requestBody: StatementUpdate,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/financials/update-statement/{statement_id}',
            path: {
                'entity_id': entityId,
                'statement_id': statementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Statement
     * @param entityId
     * @param statementId
     * @param deleteDependencies
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteStatement(
        entityId: string,
        statementId: string,
        deleteDependencies: boolean = false,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/entities/{entity_id}/financials/delete-statement/{statement_id}',
            path: {
                'entity_id': entityId,
                'statement_id': statementId,
            },
            query: {
                'delete_dependencies': deleteDependencies,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Statements
     * @param entityId
     * @returns StatementRead Successful Response
     * @throws ApiError
     */
    public listStatements(
        entityId: string,
    ): CancelablePromise<Array<StatementRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/financials/list-statements',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Statement For Entity
     * @param entityId
     * @param statementId
     * @param startDate
     * @param endDate
     * @returns StatementReport Successful Response
     * @throws ApiError
     */
    public getStatementForEntity(
        entityId: string,
        statementId: string,
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<StatementReport> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/financials/get-statement/{statement_id}',
            path: {
                'entity_id': entityId,
                'statement_id': statementId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Effective Date Range For Statement
     * @param entityId
     * @param statementId
     * @returns string Successful Response
     * @throws ApiError
     */
    public getEffectiveDateRangeForStatement(
        entityId: string,
        statementId: string,
    ): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/financials/get-latest-effective-date-for-statement/{statement_id}',
            path: {
                'entity_id': entityId,
                'statement_id': statementId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Export Statement For Entity Id
     * @param entityId
     * @param statementId
     * @param startDate
     * @param endDate
     * @returns string Successful Response
     * @throws ApiError
     */
    public exportStatementForEntityId(
        entityId: string,
        statementId: string,
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/financials/export-statement',
            path: {
                'entity_id': entityId,
            },
            query: {
                'statement_id': statementId,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Calculate Line Item Values
     * @param entityId
     * @param statementId
     * @param requestBody
     * @returns CalculateLineItemValueModResult Successful Response
     * @throws ApiError
     */
    public calculateLineItemValues(
        entityId: string,
        statementId: string,
        requestBody: CalculateLineItemValuesPayload,
    ): CancelablePromise<Record<string, CalculateLineItemValueModResult>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/financials/calculate-line-item-values/{statement_id}',
            path: {
                'entity_id': entityId,
                'statement_id': statementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Mappings By Line Item Id
     * @param entityId
     * @param statementId
     * @returns MappingPropertyRead Successful Response
     * @throws ApiError
     */
    public listMappingsByLineItemId(
        entityId: string,
        statementId: string,
    ): CancelablePromise<Record<string, Array<MappingPropertyRead>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/financials/list_mappings_by_line_item_id/{statement_id}',
            path: {
                'entity_id': entityId,
                'statement_id': statementId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Properties For Entity
     * @param entityId
     * @returns PropertyRead Successful Response
     * @throws ApiError
     */
    public listPropertiesForEntity(
        entityId: string,
    ): CancelablePromise<Array<PropertyRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/properties/list-properties-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Property Id By Asset Account Id
     * @param entityId
     * @returns string Successful Response
     * @throws ApiError
     */
    public getPropertyIdByAssetAccountId(
        entityId: string,
    ): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/properties/get-property-id-by-asset-account-id',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Formulas With Values For Entity
     * @param entityId
     * @param startDate
     * @param endDate
     * @param scenarioId
     * @param periodType
     * @param globalAsOfDate
     * @returns FormulaEntityResult Successful Response
     * @throws ApiError
     */
    public listFormulasWithValuesForEntity(
        entityId: string,
        startDate: string,
        endDate: string,
        scenarioId?: (string | null),
        periodType?: (PeriodTypeEnum | null),
        globalAsOfDate?: (string | null),
    ): CancelablePromise<Array<FormulaEntityResult>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/properties/list-formulas-with-values-for-entity/{start_date}/{end_date}',
            path: {
                'entity_id': entityId,
                'start_date': startDate,
                'end_date': endDate,
            },
            query: {
                'scenario_id': scenarioId,
                'period_type': periodType,
                'global_as_of_date': globalAsOfDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cashflow Formulas With Values For Entity
     * Evaluate all cashflow formulas for an entity using the resolver pipeline.
     *
     * This endpoint returns all cashflow formulas (DPI, IRR, MOIC, etc.) applicable to
     * the entity, evaluated with private cashflow metric materialization.
     * @param entityId
     * @param requestBody
     * @returns FormulaEntityResult Successful Response
     * @throws ApiError
     */
    public listCashflowFormulasWithValuesForEntity(
        entityId: string,
        requestBody: CashflowFormulaFiltersForEntity,
    ): CancelablePromise<Array<FormulaEntityResult>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/properties/list-cashflow-formulas-with-values-for-entity',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Field Value Restatements
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public saveFieldValueRestatements(
        entityId: string,
        requestBody: RestateFieldValuesPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/fields/save-field-value-restatements',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Formulas For Entity
     * @param entityId
     * @returns FormulaRead Successful Response
     * @throws ApiError
     */
    public listFormulasForEntity(
        entityId: string,
    ): CancelablePromise<Array<FormulaRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/fields/list-formulas-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Field Value For Id
     * Delete a field value by its ID.
     *
     * Args:
     * entity_id: The entity ID (for permission checking)
     * field_value_id: The ID of the field value to delete
     *
     * Returns:
     * None
     * @param entityId
     * @param fieldValueId
     * @param fieldId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteFieldValueForId(
        entityId: string,
        fieldValueId: string,
        fieldId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/entities/{entity_id}/fields/delete-field-value/{field_value_id}',
            path: {
                'entity_id': entityId,
                'field_value_id': fieldValueId,
            },
            query: {
                'field_id': fieldId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Institutions With Asset Accounts
     * @param entityId
     * @param ignoreArchived
     * @param asOf
     * @param sourceType
     * @returns FinancialInstitutionWithAssetAccounts Successful Response
     * @throws ApiError
     */
    public listInstitutionsWithAssetAccounts(
        entityId: string,
        ignoreArchived?: (boolean | null),
        asOf?: (string | null),
        sourceType?: (BalanceSourceTypeEnum | null),
    ): CancelablePromise<Array<FinancialInstitutionWithAssetAccounts>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/asset-accounts/list-institutions-with-asset-accounts',
            path: {
                'entity_id': entityId,
            },
            query: {
                'ignore_archived': ignoreArchived,
                'as_of': asOf,
                'source_type': sourceType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Asset Accounts With Institution Connection Status
     * has nothing to do w/ balances - simply get asset accounts and institution connection data
     * @param entityId
     * @returns AssetAccountWithInstitutionConnection Successful Response
     * @throws ApiError
     */
    public listAssetAccountsWithInstitutionConnectionStatus(
        entityId: string,
    ): CancelablePromise<Array<AssetAccountWithInstitutionConnection>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/asset-accounts/list_asset_accounts_with_institution_connection_status',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Asset Documents For Institution
     * @param entityId
     * @returns FinancialInstitutionWithAssetAccounts Successful Response
     * @throws ApiError
     */
    public listAssetDocumentsForInstitution(
        entityId: string,
    ): CancelablePromise<Array<FinancialInstitutionWithAssetAccounts>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/asset-accounts/list-asset-documents-for-institution',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Asset Account Balances For Date
     * @param entityId
     * @param asOfDate
     * @returns AssetAccountBalanceRead Successful Response
     * @throws ApiError
     */
    public listAssetAccountBalancesForDate(
        entityId: string,
        asOfDate: string,
    ): CancelablePromise<Array<AssetAccountBalanceRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/asset-accounts/list-asset-account-balances-for-date/{as_of_date}',
            path: {
                'entity_id': entityId,
                'as_of_date': asOfDate,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Asset Account Balances Over Time
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public listAssetAccountBalancesOverTime(
        entityId: string,
    ): CancelablePromise<Array<Record<string, any>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/asset-accounts/list-asset-account-balances-over-time',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Asset Account Documents
     * @param entityId
     * @param institutionId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public createAssetAccountDocuments(
        entityId: string,
        institutionId: string,
        requestBody: AssetAccountDocumentCreatePayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/asset-accounts/create-asset-account-documents/{institution_id}',
            path: {
                'entity_id': entityId,
                'institution_id': institutionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Asset Account Documents
     * @param entityId
     * @param institutionId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateAssetAccountDocuments(
        entityId: string,
        institutionId: string,
        requestBody: AssetAccountDocumentUpdatePayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/asset-accounts/update-asset-account-documents/{institution_id}',
            path: {
                'entity_id': entityId,
                'institution_id': institutionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Asset Accounts For Financial Connection
     * @param entityId
     * @param financialConnectionId
     * @returns AssetAccountWithDetails Successful Response
     * @throws ApiError
     */
    public listAssetAccountsForFinancialConnection(
        entityId: string,
        financialConnectionId: string,
    ): CancelablePromise<Array<AssetAccountWithDetails>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/asset-accounts/list-asset-accounts-for-financial-connection/{financial_connection_id}',
            path: {
                'entity_id': entityId,
                'financial_connection_id': financialConnectionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Asset Accounts
     * Used in the post-connect from plaid workflow
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateAssetAccounts(
        entityId: string,
        requestBody: UpdateAssetAccountsPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/asset-accounts/update-asset-accounts',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Connect Token
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public createConnectToken(
        entityId: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/asset-accounts/create-connect-token',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Connect Token For Repair
     * @param entityId
     * @param localConnectionId
     * @returns any Successful Response
     * @throws ApiError
     */
    public createConnectTokenForRepair(
        entityId: string,
        localConnectionId: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/asset-accounts/create-connect-token-for-repair',
            path: {
                'entity_id': entityId,
            },
            query: {
                'local_connection_id': localConnectionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Asset Account Documents
     * @param entityId
     * @param documentId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteAssetAccountDocuments(
        entityId: string,
        documentId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/asset-accounts/delete-asset-account-documents',
            path: {
                'entity_id': entityId,
            },
            query: {
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Analyze Bank Document
     * Kick off bank document analysis as a background task.
     *
     * Sends the document to Gemini directly.
     * Results are delivered via WebSocket on channel bank_document_analysis:{entity_id}.
     * @param entityId
     * @param documentId
     * @returns any Successful Response
     * @throws ApiError
     */
    public analyzeBankDocument(
        entityId: string,
        documentId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/asset-accounts/analyze-bank-document',
            path: {
                'entity_id': entityId,
            },
            query: {
                'document_id': documentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Analyze Bank Statements
     * Kick off Gemini analysis of uploaded bank statements (one task per file).
     *
     * Each statement yields every account and ending balance it contains; results are delivered via
     * WebSocket on channel bank_statement_analysis:{entity_id} so the Financial Accounts task block
     * can fill the balance of every matched account, not just one. Tasks are enqueued with a
     * staggered delay because simultaneous Gemini calls for a multi-statement batch exhaust the
     * Vertex AI per-minute quota (429 RESOURCE_EXHAUSTED).
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public analyzeBankStatements(
        entityId: string,
        requestBody: AnalyzeBankStatementsPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/asset-accounts/analyze-bank-statements',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Documents For Entity
     * @param entityId
     * @param requestBody
     * @returns DocumentDetail Successful Response
     * @throws ApiError
     */
    public listDocumentsForEntity(
        entityId: string,
        requestBody?: (ListDocumentsPayload | null),
    ): CancelablePromise<Array<DocumentDetail>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/documents/list-documents-for-entity',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Processing Documents For Entity
     * List all documents with index_status of PROCESSING for an entity.
     *
     * Args:
     * entity_id: The ID of the entity
     *
     * Returns:
     * List of DocumentRead objects with index_status PROCESSING
     * @param entityId
     * @returns DocumentRead Successful Response
     * @throws ApiError
     */
    public listProcessingDocumentsForEntity(
        entityId: string,
    ): CancelablePromise<Array<DocumentRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/documents/list-processing-documents',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Document Copy Records For Entity
     * @param entityId
     * @returns DocumentCopyRecordWithDetails Successful Response
     * @throws ApiError
     */
    public listDocumentCopyRecordsForEntity(
        entityId: string,
    ): CancelablePromise<Array<DocumentCopyRecordWithDetails>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/documents/list-document-copy-records-for-entity/',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Deliverable
     * @param entityId
     * @param requestBody
     * @param firstAssignmentDate
     * @returns string Successful Response
     * @throws ApiError
     */
    public createDeliverable(
        entityId: string,
        requestBody: CollectionPlanCreate,
        firstAssignmentDate?: (string | null),
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/create-deliverable',
            path: {
                'entity_id': entityId,
            },
            query: {
                'first_assignment_date': firstAssignmentDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Copy Deliverable
     * @param entityId
     * @param workflowId
     * @param clusterId
     * @returns WorkflowCreatePayload Successful Response
     * @throws ApiError
     */
    public copyDeliverable(
        entityId: string,
        workflowId: string,
        clusterId: string,
    ): CancelablePromise<WorkflowCreatePayload> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/copy-deliverable',
            path: {
                'entity_id': entityId,
            },
            query: {
                'workflow_id': workflowId,
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Deliverable
     * @param entityId
     * @param collectionPlanId
     * @param requestBody
     * @returns CollectionPlanRead Successful Response
     * @throws ApiError
     */
    public saveDeliverable(
        entityId: string,
        collectionPlanId: string,
        requestBody: CollectionPlanCreate,
    ): CancelablePromise<CollectionPlanRead> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/orchestration/save-reporting-requirement/{collection_plan_id}',
            path: {
                'entity_id': entityId,
                'collection_plan_id': collectionPlanId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Entity Details
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateEntityDetails(
        entityId: string,
        requestBody: EntityDetailsUpdate,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/orchestration/update-entity-details',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Clone And Complete Entity Task
     * will clone the task and response from the payload w/ all new IDs while maintaining the references between blocks
     * inside this task
     *
     * we want to use this to essentially 'resubmit' a task which we want to show up to clusters as another row
     * in their deliverables from the borrower which they can view/delete/whatever independently
     * @param entityId
     * @param taskId
     * @param requestBody
     * @returns TaskRead Successful Response
     * @throws ApiError
     */
    public cloneAndCompleteEntityTask(
        entityId: string,
        taskId: string,
        requestBody: CompleteTaskPayload,
    ): CancelablePromise<TaskRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/clone-and-complete-entity-task/{task_id}',
            path: {
                'entity_id': entityId,
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Draft For Edit
     * Create a draft clone of a completed task for editing. The draft can be saved
     * incrementally and resubmitted later via complete-entity-task.
     * Idempotent: returns existing draft if one already exists for this task's global_version_id.
     *
     * When a payload is provided, the draft is populated with the payload values (the user's
     * current form state) instead of reading from the original task's DB responses. This mirrors
     * the pattern of clone_and_complete_entity_task.
     * @param entityId
     * @param taskId
     * @param requestBody
     * @returns TaskWithBlocks Successful Response
     * @throws ApiError
     */
    public createDraftForEdit(
        entityId: string,
        taskId: string,
        requestBody?: (CompleteTaskPayload | null),
    ): CancelablePromise<TaskWithBlocks> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/create-draft-for-edit/{task_id}',
            path: {
                'entity_id': entityId,
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Complete Task From Template
     * @param entityId
     * @param taskTemplateId
     * @param requestBody
     * @returns TaskRead Successful Response
     * @throws ApiError
     */
    public completeTaskFromTemplate(
        entityId: string,
        taskTemplateId: string,
        requestBody: CompleteTaskPayload,
    ): CancelablePromise<TaskRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/complete-task-from-template/{task_template_id}',
            path: {
                'entity_id': entityId,
                'task_template_id': taskTemplateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Entity Task Summary
     * @param entityId
     * @returns TaskSummary Successful Response
     * @throws ApiError
     */
    public getEntityTaskSummary(
        entityId: string,
    ): CancelablePromise<Record<string, Array<TaskSummary>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/orchestration/get-entity-task-summary',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Commentary For Entity
     * Gets all commentary entries for an entity from the commentary feed properties.
     *
     * Returns a list of CommentaryDomain objects ordered by effective date (latest first).
     * @param entityId
     * @returns CommentaryDomain Successful Response
     * @throws ApiError
     */
    public listCommentaryForEntity(
        entityId: string,
    ): CancelablePromise<Array<CommentaryDomain>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/orchestration/list-commentary-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Statement
     * @param entityId
     * @param statementId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateStatement1(
        entityId: string,
        statementId: string,
        requestBody: UpdateStatementBody,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/orchestration/update-statement/{statement_id}',
            path: {
                'entity_id': entityId,
                'statement_id': statementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Field Values For Entity
     * @param entityId
     * @param asOfDate
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public saveFieldValuesForEntity(
        entityId: string,
        asOfDate: string,
        requestBody: UpdateFieldValuesPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/save-field-values-for-entity',
            path: {
                'entity_id': entityId,
            },
            query: {
                'as_of_date': asOfDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Dependency Context For Lx
     * @param entityId
     * @param lxCode
     * @returns DependenciesContext Successful Response
     * @throws ApiError
     */
    public getDependencyContextForLx(
        entityId: string,
        lxCode: string,
    ): CancelablePromise<DependenciesContext> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/orchestration/get-dependency-context-for-lx',
            path: {
                'entity_id': entityId,
            },
            query: {
                'lx_code': lxCode,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Publish Data Extraction Results
     * @param entityId
     * @param dataExtractionId
     * @param requestBody
     * @param markTaskComplete
     * @param publishAll
     * @returns any Successful Response
     * @throws ApiError
     */
    public publishDataExtractionResults(
        entityId: string,
        dataExtractionId: any,
        requestBody: DataExtractionPayload,
        markTaskComplete?: (boolean | null),
        publishAll: boolean = false,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/publish-data-extraction-results-for-payload/{data_extraction_id}',
            path: {
                'entity_id': entityId,
                'data_extraction_id': dataExtractionId,
            },
            query: {
                'mark_task_complete': markTaskComplete,
                'publish_all': publishAll,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Enable Tentacle Mode Bank Connections
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public enableTentacleModeBankConnections(
        entityId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/orchestration/enable-tentacle-mode-bank-connections',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Disable Tentacle Mode Bank Connections
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public disableTentacleModeBankConnections(
        entityId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/orchestration/disable-tentacle-mode-bank-connections',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Disconnect Financial Connection
     * @param entityId
     * @param localConnectionId
     * @param assetAccountId
     * @param archive
     * @returns any Successful Response
     * @throws ApiError
     */
    public disconnectFinancialConnection(
        entityId: string,
        localConnectionId: string,
        assetAccountId?: (string | null),
        archive?: (boolean | null),
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/disconnect-financial-connection',
            path: {
                'entity_id': entityId,
            },
            query: {
                'local_connection_id': localConnectionId,
                'asset_account_id': assetAccountId,
                'archive': archive,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Asset Account For Entity
     * @param entityId
     * @param requestBody
     * @returns AssetAccountRead Successful Response
     * @throws ApiError
     */
    public createAssetAccountForEntity(
        entityId: string,
        requestBody: AssetAccountCreate,
    ): CancelablePromise<AssetAccountRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/create-asset-account',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Asset Accounts For Entity
     * Create multiple asset accounts for an entity in bulk.
     *
     * Uses the bulk service method for optimized performance when creating
     * multiple accounts at once.
     * @param entityId
     * @param requestBody
     * @returns number Successful Response
     * @throws ApiError
     */
    public createAssetAccountsForEntity(
        entityId: string,
        requestBody: BulkCreateAssetAccounts,
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/create-asset-accounts',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Financial Connection
     * @param entityId
     * @param remoteConnectionId
     * @param requestBody
     * @returns FinancialConnectionRead Successful Response
     * @throws ApiError
     */
    public createFinancialConnection(
        entityId: string,
        remoteConnectionId: string,
        requestBody: Record<string, any>,
    ): CancelablePromise<FinancialConnectionRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/create-financial-connection',
            path: {
                'entity_id': entityId,
            },
            query: {
                'remote_connection_id': remoteConnectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Financial Connection
     * @param entityId
     * @param localConnectionId
     * @param remoteConnectionId
     * @param requestBody
     * @returns FinancialConnectionRead Successful Response
     * @throws ApiError
     */
    public updateFinancialConnection(
        entityId: string,
        localConnectionId: string,
        remoteConnectionId: string,
        requestBody: Record<string, any>,
    ): CancelablePromise<FinancialConnectionRead> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/orchestration/update-financial-connection',
            path: {
                'entity_id': entityId,
            },
            query: {
                'local_connection_id': localConnectionId,
                'remote_connection_id': remoteConnectionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Add Entity Membership
     * @param entityId
     * @param requestBody
     * @returns MembershipRead Successful Response
     * @throws ApiError
     */
    public addEntityMembership(
        entityId: string,
        requestBody: AddEntityMembershipPayload,
    ): CancelablePromise<MembershipRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/add-membership',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Resend Entity Invitation
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public resendEntityInvitation(
        entityId: string,
        requestBody: ResendInvitationPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/resend-entity-invitation',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Invite Entity
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public inviteEntity(
        entityId: string,
        requestBody: InviteEntityPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/orchestration/invite-entity',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Entity
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteEntity(
        entityId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/entities/{entity_id}/orchestration/delete-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Deactivate Entity
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deactivateEntity(
        entityId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/orchestration/deactivate-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Map Config Values By Type For Entity
     * @param entityId
     * @returns ConfigValueEnum Successful Response
     * @throws ApiError
     */
    public mapConfigValuesByTypeForEntity(
        entityId: string,
    ): CancelablePromise<Record<string, ConfigValueEnum>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/module-configs/map-config-values-by-type-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Databases For Entity
     * @param entityId
     * @returns DatabaseRead Successful Response
     * @throws ApiError
     */
    public listDatabasesForEntity(
        entityId: string,
    ): CancelablePromise<Array<DatabaseRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/databases/list-databases-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Database For Entity
     * @param entityId
     * @param databaseId
     * @returns DatabaseWithRowsAndColumns Successful Response
     * @throws ApiError
     */
    public getDatabaseForEntity(
        entityId: string,
        databaseId: string,
    ): CancelablePromise<DatabaseWithRowsAndColumns> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/databases/get-database-for-entity/{database_id}',
            path: {
                'entity_id': entityId,
                'database_id': databaseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Modify Database Rows
     * @param entityId
     * @param databaseId
     * @param requestBody
     * @returns DatabaseWithRowsAndColumns Successful Response
     * @throws ApiError
     */
    public modifyDatabaseRows(
        entityId: string,
        databaseId: string,
        requestBody: ModifyDatabaseRowsPayload,
    ): CancelablePromise<DatabaseWithRowsAndColumns> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/databases/modify-database-rows/{database_id}',
            path: {
                'entity_id': entityId,
                'database_id': databaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Add Tracked Database
     * @param entityId
     * @param databaseId
     * @returns TrackedDatabaseRead Successful Response
     * @throws ApiError
     */
    public addTrackedDatabase(
        entityId: string,
        databaseId: string,
    ): CancelablePromise<TrackedDatabaseRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/databases/add-tracked-database/{database_id}',
            path: {
                'entity_id': entityId,
                'database_id': databaseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Remove Tracked Database
     * @param entityId
     * @param databaseId
     * @returns any Successful Response
     * @throws ApiError
     */
    public removeTrackedDatabase(
        entityId: string,
        databaseId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/entities/{entity_id}/databases/remove-tracked-database/{database_id}',
            path: {
                'entity_id': entityId,
                'database_id': databaseId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Reports For Entity
     * @param entityId
     * @returns ReportRead Successful Response
     * @throws ApiError
     */
    public listReportsForEntity(
        entityId: string,
    ): CancelablePromise<Array<ReportRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/reports/list-reports-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Workflow For Entity
     * @param entityId
     * @param requestBody
     * @returns WorkflowCreatePayload Successful Response
     * @throws ApiError
     */
    public createWorkflowForEntity(
        entityId: string,
        requestBody: WorkflowCreatePayload,
    ): CancelablePromise<WorkflowCreatePayload> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/workflows/create-workflow-for-entity',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Workflows For Entity
     * @param entityId
     * @returns WorkflowSummary Successful Response
     * @throws ApiError
     */
    public listWorkflowsForEntity(
        entityId: string,
    ): CancelablePromise<Array<WorkflowSummary>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/workflows/list-workflows-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Document Automation Summaries For Entity
     * @param entityId
     * @returns DocumentAutomationSummary Successful Response
     * @throws ApiError
     */
    public listDocumentAutomationSummariesForEntity(
        entityId: string,
    ): CancelablePromise<Array<DocumentAutomationSummary>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/workflows/list-document-automation-summaries-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Add Tracked Time Series Models
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public addTrackedTimeSeriesModels(
        entityId: string,
        requestBody: Array<string>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/tsm/add-tracked-time-series-models',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Remove Tracked Time Series Model
     * @param entityId
     * @param tsmId
     * @returns any Successful Response
     * @throws ApiError
     */
    public removeTrackedTimeSeriesModel(
        entityId: string,
        tsmId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/tsm/remove-tracked-time-series-model/{tsm_id}',
            path: {
                'entity_id': entityId,
                'tsm_id': tsmId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Dashboards For Entity
     * @param entityId
     * @param clusterId
     * @returns EntityDashboard Successful Response
     * @throws ApiError
     */
    public listDashboardsForEntity(
        entityId: string,
        clusterId: string,
    ): CancelablePromise<Array<EntityDashboard>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/dashboards/list-dashboards-for-entity',
            path: {
                'entity_id': entityId,
            },
            query: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Reorder Dashboards For Entity
     * @param entityId
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderDashboardsForEntity(
        entityId: string,
        clusterId: string,
        requestBody: Array<string>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/dashboards/reorder-dashboards-for-entity',
            path: {
                'entity_id': entityId,
            },
            query: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Remove Entity Dashboard Ordering
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public removeEntityDashboardOrdering(
        entityId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/dashboards/remove-entity-dashboard-ordering',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Entity Dashboard Presence
     * Get current presence state for a dashboard viewed on an entity.
     *
     * Async route: the blocking Redis reads are offloaded via ``run_in_threadpool``
     * so they do not block the event loop.
     * @param dashboardId
     * @param entityId
     * @returns EntityDashboardPresenceRead Successful Response
     * @throws ApiError
     */
    public getEntityDashboardPresence(
        dashboardId: string,
        entityId: string,
    ): CancelablePromise<EntityDashboardPresenceRead> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/dashboards/entity-dashboard-presence/{dashboard_id}',
            path: {
                'dashboard_id': dashboardId,
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Leave Entity Dashboard Presence
     * Clear user presence when leaving an entity dashboard view.
     * @param dashboardId
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public leaveEntityDashboardPresence(
        dashboardId: string,
        entityId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/entities/{entity_id}/dashboards/entity-dashboard-presence/{dashboard_id}',
            path: {
                'dashboard_id': dashboardId,
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Heartbeat Entity Dashboard Presence
     * Heartbeat to maintain user presence on an entity dashboard (every 15 seconds).
     *
     * Async route: the blocking Redis/DB body is offloaded via ``run_in_threadpool``
     * (no async driver). That primitive is non-cancellable, so a cancelled request
     * cannot orphan the body while it holds the request's DB session.
     * @param dashboardId
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public heartbeatEntityDashboardPresence(
        dashboardId: string,
        entityId: string,
        requestBody: EntityDashboardPresenceHeartbeatPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/dashboards/entity-dashboard-presence/{dashboard_id}/heartbeat',
            path: {
                'dashboard_id': dashboardId,
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Notify Entity Dashboard Saved
     * Notify other cluster members that this entity dashboard was saved (stale-data warning).
     *
     * Called by the frontend after a successful save. Kept separate from the shared
     * save endpoint so the entity-scoped broadcast stays additive.
     * @param dashboardId
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public notifyEntityDashboardSaved(
        dashboardId: string,
        entityId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/dashboards/entity-dashboard-presence/{dashboard_id}/notify-saved',
            path: {
                'dashboard_id': dashboardId,
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Bindings For Assigned Dashboard
     * Get variable bindings for an assigned dashboard as a name->value dict.
     * @param entityId
     * @param dashboardId
     * @param assignedDashboardId
     * @returns string Successful Response
     * @throws ApiError
     */
    public getBindingsForAssignedDashboard(
        entityId: string,
        dashboardId: string,
        assignedDashboardId: string,
    ): CancelablePromise<Record<string, string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/dashboards/bindings/{dashboard_id}/{assigned_dashboard_id}',
            path: {
                'entity_id': entityId,
                'dashboard_id': dashboardId,
                'assigned_dashboard_id': assignedDashboardId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Entity Dashboard Bindings
     * Save variable bindings for an assigned dashboard (by entity context).
     * @param entityId
     * @param dashboardId
     * @param assignedDashboardId
     * @param requestBody
     * @returns DashboardVariableBindRead Successful Response
     * @throws ApiError
     */
    public saveEntityDashboardBindings(
        entityId: string,
        dashboardId: string,
        assignedDashboardId: string,
        requestBody: Record<string, string>,
    ): CancelablePromise<Array<DashboardVariableBindRead>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/dashboards/bindings/{dashboard_id}/{assigned_dashboard_id}',
            path: {
                'entity_id': entityId,
                'dashboard_id': dashboardId,
                'assigned_dashboard_id': assignedDashboardId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Lens
     * @param entityId
     * @param requestBody
     * @returns LensRead Successful Response
     * @throws ApiError
     */
    public createLens(
        entityId: string,
        requestBody: LensPayload,
    ): CancelablePromise<LensRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/create-lens',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Lenses For Entity
     * @param entityId
     * @returns LensPayload Successful Response
     * @throws ApiError
     */
    public listLensesForEntity(
        entityId: string,
    ): CancelablePromise<Array<LensPayload>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/data-extraction/list-lenses-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Data Extraction Summaries For Entity
     * @param entityId
     * @returns DataExtractionSummary Successful Response
     * @throws ApiError
     */
    public listDataExtractionSummariesForEntity(
        entityId: string,
    ): CancelablePromise<Array<DataExtractionSummary>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/data-extraction/list-data-extraction-summaries-for-entity',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Previous Mappings For Lens Ids
     * @param entityId
     * @param dataExtractionId
     * @param requestBody
     * @param maximumEffectiveDate
     * @returns MappingPayload Successful Response
     * @throws ApiError
     */
    public listPreviousMappingsForLensIds(
        entityId: string,
        dataExtractionId: string,
        requestBody: Array<string>,
        maximumEffectiveDate?: (string | null),
    ): CancelablePromise<Array<MappingPayload>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/list-previous-mappings-for-lens-ids/{data_extraction_id}',
            path: {
                'entity_id': entityId,
                'data_extraction_id': dataExtractionId,
            },
            query: {
                'maximum_effective_date': maximumEffectiveDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Data Extraction
     * @param entityId
     * @param dataExtractionId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public saveDataExtraction(
        entityId: string,
        dataExtractionId: any,
        requestBody: DataExtractionPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/save-data-extraction',
            path: {
                'entity_id': entityId,
            },
            query: {
                'data_extraction_id': dataExtractionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Save Data Extraction Context
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public saveDataExtractionContext(
        entityId: string,
        requestBody: RenderableRichText,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/entities/{entity_id}/data-extraction/save-data-extraction-context',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Render Data Extraction Context
     * @param entityId
     * @param clusterId
     * @param namespaceId
     * @param relativeToDate
     * @param requestBody
     * @returns RenderedRichText Successful Response
     * @throws ApiError
     */
    public renderDataExtractionContext(
        entityId: string,
        clusterId: string,
        namespaceId: string,
        relativeToDate: string,
        requestBody: RenderDataExtractionContextPayload,
    ): CancelablePromise<RenderedRichText> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/render-data-extraction-context/{cluster_id}/{namespace_id}',
            path: {
                'entity_id': entityId,
                'cluster_id': clusterId,
                'namespace_id': namespaceId,
            },
            query: {
                'relative_to_date': relativeToDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Renderable Data Extraction Context
     * @param entityId
     * @returns RenderableRichText Successful Response
     * @throws ApiError
     */
    public getRenderableDataExtractionContext(
        entityId: string,
    ): CancelablePromise<RenderableRichText> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/data-extraction/get-renderable-data-extraction-context',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Calculate Data Extraction Results For Payload
     * @param entityId
     * @param dataExtractionId
     * @param requestBody
     * @param forceBustCache
     * @param focusedDocumentId
     * @returns DataExtractionResults Successful Response
     * @throws ApiError
     */
    public calculateDataExtractionResultsForPayload(
        entityId: string,
        dataExtractionId: any,
        requestBody: DataExtractionPayload,
        forceBustCache: boolean = false,
        focusedDocumentId?: (string | null),
    ): CancelablePromise<DataExtractionResults> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/calculate-data-extraction-results-for-payload/{data_extraction_id}',
            path: {
                'entity_id': entityId,
                'data_extraction_id': dataExtractionId,
            },
            query: {
                'force_bust_cache': forceBustCache,
                'focused_document_id': focusedDocumentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Generate Mappings
     * @param entityId
     * @param requestBody
     * @returns AutoMappingAIPayload Successful Response
     * @throws ApiError
     */
    public generateMappings(
        entityId: string,
        requestBody: GenerateMappingsPayload,
    ): CancelablePromise<Array<AutoMappingAIPayload>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/generate-mappings',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Extract Fields From Document
     * Kick off field discovery as a background task.
     *
     * Sends the document to Gemini directly (no RAG/indexing needed).
     * Results are delivered via WebSocket on channel field_discovery:{entity_id}.
     * @param entityId
     * @param documentId
     * @param prompt
     * @returns FieldDiscoveryStartResponse Successful Response
     * @throws ApiError
     */
    public extractFieldsFromDocument(
        entityId: string,
        documentId: string,
        prompt?: (string | null),
    ): CancelablePromise<FieldDiscoveryStartResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/extract-fields-from-document',
            path: {
                'entity_id': entityId,
            },
            query: {
                'document_id': documentId,
                'prompt': prompt,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Extract With Lu
     * RAG chat endpoint with streaming via WebSocket
     * @param entityId
     * @param conversationId
     * @param dataExtractionId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public extractWithLu(
        entityId: string,
        conversationId: string,
        dataExtractionId: any,
        requestBody?: (src__app__collection__data_extraction__router__LuChatPromptPayload | null),
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/extract-with-lu/{conversation_id}/{data_extraction_id}',
            path: {
                'entity_id': entityId,
                'conversation_id': conversationId,
                'data_extraction_id': dataExtractionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Or Update Ai Extraction Context
     * Create or update AI extraction context for an entity.
     * @param entityId
     * @param requestBody
     * @returns AIExtractionContextRead Successful Response
     * @throws ApiError
     */
    public createOrUpdateAiExtractionContext(
        entityId: string,
        requestBody: AIExtractionContextCreate,
    ): CancelablePromise<AIExtractionContextRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/ai-extraction-context',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Ai Extraction Context
     * Get AI extraction context for an entity.
     * @param entityId
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAiExtractionContext(
        entityId: string,
    ): CancelablePromise<(AIExtractionContextRead | null)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/data-extraction/ai-extraction-context',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Simulate Historical Mapping
     * Simulates historical mapping for the given entity using the provided mapping.
     *
     * Pass ?run_async=true to run in background via Dramatiq. When async, the worker sends one
     * WebSocket message on ``historical_mapping_simulation:{request_id}`` with payload
     * ``{status: completed, results: [...]}`` — the same list shape as the synchronous response.
     * Without the flag, returns that JSON array directly.
     * @param entityId
     * @param requestBody
     * @param runAsync
     * @returns any Successful Response
     * @throws ApiError
     */
    public simulateHistoricalMapping(
        entityId: string,
        requestBody: MappingPayload,
        runAsync: boolean = false,
    ): CancelablePromise<(Record<string, any> | Array<SimulatedMappingResponse>)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/simulate-historical-mapping',
            path: {
                'entity_id': entityId,
            },
            query: {
                'run_async': runAsync,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Backfill Mapping
     * Backfills field values by running a mapping expression on historical data extractions.
     *
     * This endpoint creates a copy of the mapping for each specified data extraction
     * and saves the calculated field values.
     * @param entityId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public backfillMapping(
        entityId: string,
        requestBody: BackfillMappingPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/data-extraction/backfill-mapping',
            path: {
                'entity_id': entityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Ledgers With Cashflows For Entity
     * List all cashflow ledgers that have at least one cashflow linked to this entity.
     * @param entityId
     * @returns CashflowLedgerRead Successful Response
     * @throws ApiError
     */
    public listLedgersWithCashflowsForEntity(
        entityId: string,
    ): CancelablePromise<Array<CashflowLedgerRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/entities/{entity_id}/cashflows/ledgers-with-cashflows',
            path: {
                'entity_id': entityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cashflows For Entity In Ledger Paginated
     * List cashflows for a specific entity within a ledger with pagination, search, and sorting.
     * @param entityId
     * @param ledgerId
     * @param page
     * @param pageSize
     * @param search
     * @param scenarioId
     * @param orderBy
     * @param sortDirection
     * @returns PaginatedResponse Successful Response
     * @throws ApiError
     */
    public listCashflowsForEntityInLedgerPaginated(
        entityId: string,
        ledgerId: string,
        page: number = 1,
        pageSize: number = 10,
        search: string = '',
        scenarioId?: string,
        orderBy: string = 'date',
        sortDirection: string = 'desc',
    ): CancelablePromise<PaginatedResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/entities/{entity_id}/cashflows/list-for-ledger-paginated/{ledger_id}',
            path: {
                'entity_id': entityId,
                'ledger_id': ledgerId,
            },
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
                'scenario_id': scenarioId,
                'order_by': orderBy,
                'sort_direction': sortDirection,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
